import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useField } from '@unform/core';

import { FaTimes } from 'react-icons/fa'; 
import { Container, Error } from './styles';

const Input = ({ name = 'name',  placeholder, ...rest }) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { fieldName, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);

  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    })
  }, [fieldName, registerField])

  return (
    <Container isErroded={!!error} isFilled={isFilled} isFocused={isFocused}>

      <select
        placeholder={placeholder}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        ref={inputRef}
        {...rest}
      />



      {(error && !isFilled) && (
        <Error isFocused={isFocused}>
          <FaTimes size={24} color="#dc3545" />
          <span>{error}</span>

        </Error>
      )}

    </Container>
  );
}

export default Input;